import React from "react";
import PropTypes from "prop-types";

// components:
import PageHeading from "./PageHeading";
import InfoBar from "./InfoBar";
import OffsetGrid from "core/OffsetGrid";
import Heading from "core/Heading";

// styles:
import colors from "core/colors";
import {
    StyledCheckoutLayout,
    CheckoutContentSection,
    CheckoutContentContainer
} from "./styles";

const CheckoutLayout = ({
    isPrepaid,
    pageHeading,
    formSectionHeading,
    thumbnail,
    imageTitle,
    slugWithId,
    creator,
    type,
    children
}) => {
    return (
        <StyledCheckoutLayout>
            <PageHeading
                isPrepaid={isPrepaid}
                pageHeading={pageHeading}
                thumbnail={thumbnail}
                imageTitle={imageTitle}
                slugWithId={slugWithId}
                type={type}
            />

            {!isPrepaid && <InfoBar creator={creator} type={type} />}

            <CheckoutContentSection
                topSpacing="none"
                bottomSpacing="5xl"
                bgColor={colors.secondary.orca}
            >
                <OffsetGrid sm={12} md={12} lg={8}>
                    <CheckoutContentContainer isPrepaid={isPrepaid}>
                        <OffsetGrid sm={12} md={8} lg={6}>
                            {!!formSectionHeading && (
                                <Heading type="h2" size="xs" bottomSpacing="lg">
                                    {formSectionHeading}
                                </Heading>
                            )}
                            {children}
                        </OffsetGrid>
                    </CheckoutContentContainer>
                </OffsetGrid>
            </CheckoutContentSection>
        </StyledCheckoutLayout>
    );
};

CheckoutLayout.propTypes = {
    isPrepaid: PropTypes.bool,
    pageHeading: PropTypes.oneOf(["Purchase Photo", "Purchase Icon"])
        .isRequired,
    type: PropTypes.oneOf(["icons", "photos"]),
    formSectionHeading: PropTypes.string,
    thumbnail: PropTypes.string.isRequired,
    imageTitle: PropTypes.string.isRequired,
    slugWithId: PropTypes.string.isRequired,
    creator: PropTypes.shape({
        avatarUrl: PropTypes.string,
        username: PropTypes.string,
        name: PropTypes.string
    }).isRequired
};

export default CheckoutLayout;
